module.exports = __webpack_public_path__ + "img/selected3-min.a715cb1c.png";